import { UPSERT_POLICY } from '../../constants/actions/policy';

export function upsertPolicy(payload) {
    return {
        type: UPSERT_POLICY,
        payload,
    };
}
